import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LochLomond.css';

const LochLomond: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="loch-lomond" className="loch-lomond-section">
      <div className="loch-lomond-container">
        <div className="loch-lomond-content">
          <h2>{t('lochLomond.title')}</h2>
          <p className="loch-lomond-text">
            {t('lochLomond.description1')}
          </p>
          <p className="loch-lomond-text">
            {t('lochLomond.description2')}
          </p>
          <button 
            className="loch-lomond-btn"
            onClick={() => {
              const gallerySection = document.getElementById('gallery');
              if (gallerySection) {
                gallerySection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') {
              const gallerySection = document.getElementById('gallery');
              if (gallerySection) {
                gallerySection.scrollIntoView({ behavior: 'smooth' });
              }
            }}}
            aria-pressed="false"
            tabIndex={0}
            onTouchStart={e => e.currentTarget.classList.add('pressed')}
            onTouchEnd={e => e.currentTarget.classList.remove('pressed')}
            onMouseDown={e => e.currentTarget.classList.add('pressed')}
            onMouseUp={e => e.currentTarget.classList.remove('pressed')}
            onBlur={e => e.currentTarget.classList.remove('pressed')}
          >
            {t('lochLomond.learnMore')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default LochLomond; 